import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import moment from "moment"
import 'popper.js'
import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Redirect } from 'react-router-dom'
import EventBus from "../common/EventBus.js"
import GlobalHelper from "../common/GlobalHelper.jsx"
import ActionButton from "../common/button/actionbutton.component.jsx"
import ConfirmButton from "../common/button/confirmbutton.component.jsx"
import SendEmailModal from '../common/email/sendemail.component.jsx'
import Icon from "../common/icon/icon.component.jsx"
import InlineEditSchedulingAvailableFrom from '../common/inline-edit/document.component.jsx'
import InlineEditLocation from "../common/inline-edit/location.component.jsx"
import InlineEditText from "../common/inline-edit/text.component.jsx"
import InlineEditUser from "../common/inline-edit/user.component.jsx"
import SideBar from "../common/layout/sidebar.component.jsx"
import ProposalPreviewModal from '../common/proposal/previewmodal.component.jsx'
import LoadingSpinner from '../common/spinner/loading.component.jsx'
import { INTEGRATION_KEY } from '../state/integration/Constants'
import { getNylasVersion } from '../utils/common/utils'
import InlineEditSchedulingCustomFields from './InlineEditSchedulingCustomFields'
import SchedulingPageAnalytics from "./analytics.component.jsx"
import SchedulerEditorModal from './nylasv3/SchedulerEditorModal'
const queryString = require('query-string')


class SchedulingPageEdit extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            status: '',
            createdAt: null,
            redirect: '',
            sellerName: '',
            sellerId: '',
            emails: [],
            templates: [],
            schedulingPage: null,
            proposal: null,
            title: '',
            documentLink: '',
            identifierId: '',
            identifier: '',
            shareTitle: '',
            shareDescription: '',
            shareImageId: '',
            deletedAt: '',
            hash: '',
            schedulingPageId: this.props.match.params.schedulingPageId,
            loading: true,
            editable: true,
            editMode: false,
            sendSchedulingPageTemplate: null,
            allowEdit: true,
            loadingPreview: false,
            primaryColor: '',
            backgroundColor: '',
            hover: false,
            mutationObserver: null,
            sendBookingConfirmationTemplate: null,
            emailTemplateId: '',
            sendSchedulingPageEmailTemplateId: '',
            availableFrom: [],
            nylasEditor: "",
            editorModal: "",
        }
        this.deleteSchedulingPage = this.deleteSchedulingPage.bind(this)
        this.review = this.review.bind(this)
        this.refreshSchedulingPage = this.refreshSchedulingPage.bind(this)
        this.handleRefresh = this.handleRefresh.bind(this)
        this.handleEdit = this.handleEdit.bind(this)
        this.closeEditMode = this.closeEditMode.bind(this)
        this.handleCloseModal = this.handleCloseModal.bind(this)
        this.markAsInactive = this.markAsInactive.bind(this)
        this.openPreview = this.openPreview.bind(this)
        this.saveEmail = this.saveEmail.bind(this)
        this.markAsActive = this.markAsActive.bind(this)
        this.openSchedulerEditor = this.openSchedulerEditor.bind(this)
        this.onMouseEnterHandler = this.onMouseEnterHandler.bind(this)
        this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this)
        this.configureBookingConfirmationEmail = this.configureBookingConfirmationEmail.bind(this)
        this.saveConfirmationEmailDetails = this.saveConfirmationEmailDetails.bind(this)
        this.configureSendSchedulingPageEmail = this.configureSendSchedulingPageEmail.bind(this)
        this.saveSendSchedulingPageEmailDetails = this.saveSendSchedulingPageEmailDetails.bind(this)
        this.handleCloseModalAndRefresh = this.handleCloseModalAndRefresh.bind(this)

        this.openNewSchedulerModal = this.openNewSchedulerModal.bind(this)
        this.closeSchedulerModal = this.closeSchedulerModal.bind(this)

    }

    componentDidMount() {
        this.refreshSchedulingPage()
        SideBar.activateMenu('schedulingpage')
        const uri = queryString.parse(this.props.location.search)
        this.setState({
            editMode: uri.em === '1',
        })
        AppContext.getApiClient().get('/templates/send-scheduling-page/template').then(t => {
            this.setState({
                sendSchedulingPageTemplate: t,
            })
        })

        AppContext.getApiClient().get('/templates/send-booking-confirmation/template').then(t => {
            this.setState({
                sendBookingConfirmationTemplate: t,
            })
        })

        if (!this.state.proposal) {
            Promise.all(
                [AppContext.getApiClient().get('/default-proposal-options/' + 'primary-color'),
                AppContext.getApiClient().get('/default-proposal-options/' + 'background-color')]
            ).then(results => {
                this.setState({
                    primaryColor: results[0].attributes.value,
                    backgroundColor: results[1].attributes.value,
                })
            })
        }
    }

    onMouseEnterHandler() {
        this.setState({
            hover: true
        });
    }

    onMouseLeaveHandler() {
        this.setState({
            hover: false
        });
    }

    refreshSchedulingPage(value) {
        let schedulingPageId = ''
        if (value && typeof value === "string") {
            schedulingPageId = value
        }
        if (schedulingPageId && schedulingPageId !== this.state.schedulingPageId) {
            window.scrollTo(0, 0)
        }
        if (!schedulingPageId) {
            schedulingPageId = this.state.schedulingPageId
        }
        AppContext.getApiClient().get('/scheduling-pages/' + schedulingPageId).then(schedulingPage => {

            if (this.state.identifier !== schedulingPage.attributes.identifier || this.state.status !== schedulingPage.attributes.status) {
                EventBus.dispatch(EventBus.TopicUrlPathChange, {
                    path: '/scheduling-pages/' + schedulingPageId + '/edit',
                })
            }
            if (!['draft'].includes(schedulingPage.attributes.status) && schedulingPage.attributes.proposalHash) {
                AppContext.getApiClient().get('/proposals/' + schedulingPage.attributes.proposalHash).then(res => {
                    if (!res.error) {
                        this.loadProposal(res)
                    }
                })
            }
            this.setState({
                loading: false,
                schedulingPage: schedulingPage,
                schedulingPageId: schedulingPage.id,
                deletedAt: schedulingPage.attributes.deletedAt,
                identifierId: schedulingPage.attributes.identifierId,
                identifier: schedulingPage.attributes.identifier,
                status: schedulingPage.attributes.status,
                title: schedulingPage.attributes.title,
                shareTitle: schedulingPage.attributes.shareTitle,
                shareDescription: schedulingPage.attributes.shareDescription,
                shareImageId: schedulingPage.attributes.shareImageId,
                shareImage: schedulingPage.attributes.shareImage,
                createdAt: schedulingPage.attributes.createdAt,
                activatedAt: schedulingPage.attributes.activatedAt,
                sellerName: schedulingPage.attributes.seller.attributes.firstName + ' ' + schedulingPage.attributes.seller.attributes.lastName,
                locationName: schedulingPage.attributes.location ? schedulingPage.attributes.location.attributes.name : '',
                locationId: schedulingPage.attributes.locationId,
                sellerId: schedulingPage.attributes.seller.id,
                emailTemplateId: schedulingPage.attributes.emailTemplateId,
                sendSchedulingPageEmailTemplateId: schedulingPage.attributes.sendSchedulingPageEmailTemplateId,
                availableFrom: schedulingPage.attributes.availableFrom,
                editorModal: "",
            }, () => {
                this.loadExternalSchedulingPage()
            })
        })
    }

    loadExternalSchedulingPage() {
        if (this.state.schedulingPage.attributes.externalLinks && this.state.schedulingPage.attributes.externalLinks.length > 0) {
            AppContext.getApiClient().get(
                '/external-scheduling-pages/' + this.state.schedulingPage.attributes.externalLinks[0].attributes.externalId +
                '?pageEditToken=' + this.state.schedulingPage.attributes.externalLinks[0].attributes.pageEditToken + 
                '&externalAccountID=' + this.state.schedulingPage.attributes.externalLinks[0].attributes.externalAccountId).then(res => {
                    if (!res.error) {
                        this.setState({
                            externalSchedulingPage: res,
                        }, () => {
                            //reload external scheduling page on nylas modal closing
                            if (!this.state.mutationObserver) {
                                let that = this
                                const mutationObserver = new MutationObserver(function (e) {
                                    if (e[0].removedNodes && e[0].removedNodes.length > 0) {
                                        if (e[0].removedNodes[0].className = 'nylas-backdrop nylas-hidden') {
                                            that.loadExternalSchedulingPage()
                                            that.state.mutationObserver.disconnect()
                                            that.setState({
                                                mutationObserver: null,
                                            })
                                        }
                                    }
                                })
                                mutationObserver.observe(document.body, { childList: true })
                                this.setState({
                                    mutationObserver: mutationObserver,
                                })
                            }
                        })
                    }
                })
        }
    }

    openNewSchedulerModal() {
        const { schedulingPage } = this.state

        if (!schedulingPage.attributes ||
            !schedulingPage.attributes.externalLinks ||
            schedulingPage.attributes.externalLinks.length === 0) 
        {
            console.error("No external links found. Cannot open scheduler modal.")
            return
        }

        const externalAccountId = schedulingPage.attributes.externalLinks[0].attributes?.externalAccountId || ""
        const configurationId = schedulingPage.attributes.externalLinks[0].attributes?.externalId || ""
       
        const userName = schedulingPage.attributes.fromName || schedulingPage.attributes.seller.attributes.name

        const urlLink = schedulingPage.attributes.urlLink || ""

        this.setState({
            editorModal: (
                <SchedulerEditorModal 
                    externalAccountId={externalAccountId} 
                    configurationId={configurationId} 
                    userName={userName} 
                    urlLink={urlLink} 
                    isModalChangedCallback={this.closeSchedulerModal}
                />)
        })
    }

    closeSchedulerModal() {
        this.setState({
            editorModal: ""
        })
    }

    loadProposal(proposal) {
        if (proposal) {
            this.setState({
                proposal: proposal,
                hash: proposal.attributes.hash,
                pdfUri: proposal.attributes.variables.document.pdfUri,
                publicLink: proposal.attributes.publicLink,
            }, () => {
                AppContext.getApiClient().get('/proposals/' + this.state.proposal.id + '/emails').then(res => {
                    const emails = !res.error ? res.data : []
                    emails.sort((a, b) => {
                        return (moment(b.attributes.createdAt).valueOf() > moment(a.attributes.createdAt).valueOf()) ? 1 : -1
                    })
                    this.setState({
                        emails: emails.slice(0, 10),
                    })
                })
            })
        } else {
            this.setState({
                proposal: null
            })
        }
    }

    deleteSchedulingPage(event) {
        event.preventDefault()
        AppContext.getApiClient().delete('/scheduling-pages/' + this.state.schedulingPageId, {}).then(res => {
            this.refreshSchedulingPage()
        })
    }

    handleCloseModal() {
        this.setState({
            modal: ''
        })
    }

    createProposal() {
        if (this.state.proposal) {
            return Promise.resolve(this.state.proposal)
        }
        return AppContext.getApiClient().post('/proposals', {
            schedulingPageId: this.state.schedulingPageId,
            hash: this.state.schedulingPage.attributes.proposalHash,
        })
    }

    review(event) {
        event.preventDefault()
        const uri = this.state.editMode ? '?em=1' : ''
        this.createProposal().then(res => {
            this.setState({
                redirect: <Redirect to={'/proposals/' + res.attributes.hash + '/preview' + uri} />
            })
        })
    }

    handleRefresh(value) {
        this.refreshSchedulingPage(value)
    }

    handleEdit(invoiceId) {
        this.setState({
            editMode: true,
        })
        window.scrollTo(0, 0)
    }

    closeEditMode(e) {
        e.preventDefault()
        this.refreshSchedulingPage()
        this.setState({
            editMode: false,
        })
        window.scrollTo(0, 0)
    }


    saveEmail(subject, toEmail, ccEmail, content, buttonLabel, next, fromName) {
        window.scrollTo(0, 0)
        this.setState({ loading: true })
        this.createProposal().then(res => {
            if (next) {
                next()
            } else {
                this.refreshSchedulingPage(res.id)
            }
        })

    }

    markAsInactive(e) {
        e.preventDefault()
        const template = this.state.sendSchedulingPageTemplate ? this.state.sendSchedulingPageTemplate.attributes : {}
        this.saveEmail(template.subject, '', '', template.content, template.buttonLabel, () => {
            AppContext.getApiClient().post('/scheduling-pages/' + this.state.schedulingPageId + '/deactivate', {}).then(res => {
                if (res.id) {
                    this.refreshSchedulingPage(res.id)
                } else {
                    this.setState({ loading: false })
                }
            })
        })
    }

    markAsActive(e) {
        e.preventDefault()
        const template = this.state.sendSchedulingPageTemplate ? this.state.sendSchedulingPageTemplate.attributes : {}
        this.saveEmail(template.subject, '', '', template.content, template.buttonLabel, () => {
            AppContext.getApiClient().post('/scheduling-pages/' + this.state.schedulingPageId + '/activate', {}).then(res => {
                if (res.id) {
                    this.refreshSchedulingPage(res.id)
                } else {
                    this.setState({ loading: false })
                }
            })
        })
    }

    handleCloseModal() {
        this.setState({
            modal: ''
        })
    }

    handleCloseModalAndRefresh() {
        this.handleCloseModal()
        this.refreshSchedulingPage()
    }

    openPreview(event) {
        event.preventDefault()
        this.setState({
            loadingPreview: true,
        }, () => {
            this.createProposal().then(res => {
                this.setState({
                    modal: <ProposalPreviewModal
                        onClose={this.handleCloseModal}
                        hash={res.attributes.hash}
                        publicLink={res.attributes.publicLink}
                        proposalType={'scheduling-page'}
                    />,
                    loadingPreview: false,
                })
            })
        })
    }

    openSchedulerEditor(event) {
        event.preventDefault()
        event.stopPropagation()
        if (this.state.schedulingPage && this.state.schedulingPage.attributes &&
            this.state.schedulingPage.attributes.externalLinks && this.state.schedulingPage.attributes.externalLinks.length > 0) {
            nylas.scheduler.show({
                auth: {
                    pageEditToken: this.state.schedulingPage.attributes.externalLinks[0].attributes.pageEditToken,
                },
                behavior: {
                    //https://developer.nylas.com/docs/user-experience/scheduler/customization/schedule-editor/#tab-details
                    displayOnly: ['event-info', 'opening-hours'],
                },
                style: {
                    tintColor: this.state.proposal ? this.state.proposal.attributes.variables.global.primaryColor : this.state.primaryColor,
                    backgroundColor: this.state.proposal ? this.state.proposal.attributes.variables.global.backgroundColor : this.state.backgroundColor,
                },
                defaults: {},
            })
        }
    }

    configureBookingConfirmationEmail(event) {
        event.preventDefault()
        this.setState({
            modal: <SendEmailModal
                fromEmail={[this.state.schedulingPage.attributes.fromEmailAddress || this.state.sendBookingConfirmationTemplate.attributes.defaultFromEmail]}
                lastEmailSubject={this.state.schedulingPage.attributes.emailSubject || this.state.sendBookingConfirmationTemplate.attributes.subject}
                lastEmailContent={this.state.schedulingPage.attributes.emailContent || this.state.sendBookingConfirmationTemplate.attributes.content}
                onSubmit={this.saveConfirmationEmailDetails}
                onClose={this.handleCloseModalAndRefresh}
                ctaLabel={<FormattedMessage
                    id="common.send_email.modal.save_btn"
                    defaultMessage="Save"
                />}
                title={<FormattedMessage
                    id="common.send_email.modal.title_configure_confirmation_email"
                    defaultMessage="Configure booking confirmation email"
                />}
                isCustomFromName={this.state.schedulingPage.attributes.fromName != ""}
                fromName={this.state.schedulingPage.attributes.fromName ? this.state.schedulingPage.attributes.fromName : this.state.sellerName}
                noEmail={true}
                hideMainButton={true}
                templateId={this.state.emailTemplateId}
            />
        })
    }

    saveConfirmationEmailDetails(subject, toEmail, ccEmail, content, buttonLabel, pdfIncluded, templateKey, fromEmail, bccEmail, fromName) {
        AppContext.getApiClient()
            .patch('/scheduling-pages/' + this.state.schedulingPageId, {
                fromEmailAddress: fromEmail.length > 0 ? fromEmail[0] : '',
                emailSubject: subject,
                emailContent: content,
                fromName: fromName,
            })
            .then(res => {
                this.refreshSchedulingPage(res.id)
            })
    }

    configureSendSchedulingPageEmail(event) {
        event.preventDefault()
        this.setState({
            modal: <SendEmailModal
                fromEmail={[this.state.schedulingPage.attributes.sendSchedulingPageFromEmailAddress || this.state.sendSchedulingPageTemplate.attributes.defaultFromEmail]}
                lastEmailSubject={this.state.schedulingPage.attributes.sendSchedulingPageEmailSubject || this.state.sendSchedulingPageTemplate.attributes.subject}
                lastEmailContent={this.state.schedulingPage.attributes.sendSchedulingPageEmailContent || this.state.sendSchedulingPageTemplate.attributes.content}
                lastEmailButtonLabel={this.state.schedulingPage.attributes.sendSchedulingPageEmailButtonLabel || this.state.sendSchedulingPageTemplate.attributes.buttonLabel}
                onSubmit={this.saveSendSchedulingPageEmailDetails}
                onClose={this.handleCloseModalAndRefresh}
                isCustomFromName={this.state.schedulingPage.attributes.sendSchedulingPageFromName != ""}
                fromName={this.state.schedulingPage.attributes.sendSchedulingPageFromName ? this.state.schedulingPage.attributes.sendSchedulingPageFromName : this.state.sellerName}
                ctaLabel={<FormattedMessage
                    id="common.send_email.modal.save_btn"
                    defaultMessage="Save"
                />}
                title={<FormattedMessage
                    id="common.send_email.modal.title_configure_send_scheduling_page_email"
                    defaultMessage="Configure send scheduling page email"
                />}
                noEmail={true}
                templateId={this.state.sendSchedulingPageEmailTemplateId}
            />
        })
    }

    saveSendSchedulingPageEmailDetails(subject, toEmail, ccEmail, content, buttonLabel, pdfIncluded, templateKey, fromEmail, bccEmail, fromName) {
        AppContext.getApiClient()
            .patch('/scheduling-pages/' + this.state.schedulingPageId, {
                sendSchedulingPageFromEmailAddress: fromEmail.length > 0 ? fromEmail[0] : '',
                sendSchedulingPageEmailSubject: subject,
                sendSchedulingPageEmailContent: content,
                sendSchedulingPageEmailButtonLabel: buttonLabel,
                sendSchedulingPageFromName: fromName,
            })
            .then(res => {
                this.refreshSchedulingPage(res.id)
            })
    }

    render() {
        if (this.state.loading) {
            return <LoadingSpinner className="py-2" />
        }

        if (["active", "inactive"].includes(this.state.status) && !this.state.editMode) {
            return <SchedulingPageAnalytics
                schedulingPage={this.state.schedulingPage}
                proposal={this.state.proposal}
                onRefresh={this.handleRefresh}
                onEdit={this.handleEdit}
                emails={this.state.emails}
            />
        }

        const firstCol = []
        const secondCol = []

        const nylasKey = getNylasVersion()

        //Card displaying information about the scheduling page
        if (this.state.externalSchedulingPage) {
            firstCol.push(<div key={firstCol.length} className="form-group row mb-0">
                <div className="col-12">
                    <div className="card"
                        onClick={ nylasKey == INTEGRATION_KEY.NYLAS 
                            ? this.openSchedulerEditor 
                            : this.openNewSchedulerModal }
                        onMouseEnter={this.onMouseEnterHandler}
                        onMouseLeave={this.onMouseLeaveHandler}
                        style={{ cursor: this.state.hover ? 'pointer' : '' }}>
                        <div className="card-header">
                            <h5>{this.state.externalSchedulingPage.title}</h5>
                            <h6>{this.state.externalSchedulingPage.duration} <FormattedMessage
                                id="scheduling_page.edit.details.minutes_label"
                                defaultMessage="minutes"
                            /> - {this.state.externalSchedulingPage.location} <a href={'#'}
                                onMouseEnter={this.onMouseEnterHandler}
                                onMouseLeave={this.onMouseLeaveHandler}>
                                    <Icon value={'pencil-alt'} className={'ml-1 ' + (!this.state.hover ? 'text-gray' : '')} />
                                </a>
                            </h6>
                            {this.state.schedulingPage &&
                                <div>
                                    {this.state.schedulingPage.attributes.calendars.map(c => {
                                        return <div>
                                            <small>{c.attributes.title} - {c.attributes.email}</small>
                                        </div>
                                    })}
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>)
        }

        firstCol.push(<div key={firstCol.length} className="form-group row mb-0">
            <label className="col-12 col-form-label custom-form-label">
                <FormattedMessage
                    id="scheduling_page.edit.details.internal_title_label"
                    defaultMessage="Internal title"
                />
            </label>
            <div className="col-12">
                <InlineEditText
                    editable={true}
                    endPoint={'/scheduling-pages/' + this.state.schedulingPageId}
                    field={'title'}
                    value={this.state.title}
                />
            </div>
        </div>)

        firstCol.push(<div key={firstCol.length} className="form-group row mb-0">
            <label className="col-12 col-form-label custom-form-label">
                <FormattedMessage
                    id="scheduling_page.edit.details.send_scheduling_page_template_label"
                    defaultMessage="Send scheduling page email template"
                />
            </label>
            <button
                className="btn btn-outline-primary btn-sm mr-2 mb-2 ml-3" onClick={this.configureSendSchedulingPageEmail}>
                <Icon value={"envelope"} className={"mr-1"} />
                <FormattedMessage
                    id="scheduling_page.edit.configure_send_scheduling_page_email_btn"
                    defaultMessage="Configure"
                />
            </button>
        </div>)

        /*  firstCol.push(<div key={firstCol.length} className="form-group row mb-0">
             <label className="col-12 col-form-label custom-form-label">
                 <FormattedMessage
                     id="scheduling_page.edit.details.sharing_title_label"
                     defaultMessage="Sharing title"
                 />
             </label>
             <div className="col-12">
                 <InlineEditText
                     editable={true}
                     endPoint={'/scheduling-pages/' + this.state.schedulingPageId}
                     field={'shareTitle'}
                     value={this.state.shareTitle}
                 />
             </div>
         </div>)
 
         firstCol.push(<div key={firstCol.length} className="form-group row mb-0">
             <label className="col-12 col-form-label custom-form-label">
                 <FormattedMessage
                     id="scheduling_page.edit.details.sharing_image_label"
                     defaultMessage="Sharing image"
                 />
             </label>
             <div className="col-12">
                 <InlineEditImage
                     editable={true}
                     endPoint={'/scheduling-pages/' + this.state.schedulingPageId}
                     field={'shareImageId'}
                     imageField={'shareImage'}
                     value={this.state.shareImage}
                 />
             </div>
         </div>) */


        secondCol.push(<div key={secondCol.length} className="row">
            <div className="form-group row px-3 mb-0">
                <label className="col-12 col-form-label custom-form-label" htmlFor="seller">
                    <FormattedMessage
                        id="scheduling_page.edit.details.assigned_to_label"
                        defaultMessage="Assigned to"
                    />
                </label>
                <div className="col-12">
                    <InlineEditUser
                        editable={true}
                        endPoint={'/scheduling-pages/' + this.state.schedulingPageId}
                        field={'sellerId'}
                        value={this.state.sellerName}
                        userId={this.state.sellerId} />
                </div>
            </div>
        </div>)

        secondCol.push(<div key={secondCol.length} className="row">
            <div className="form-group row px-3 mb-0">
                <label className="col-12 col-form-label custom-form-label" htmlFor="location">
                    <FormattedMessage
                        id="scheduling_page.edit.details.location_label"
                        defaultMessage="Location"
                    />
                </label>
                <div className="col-12">
                    <InlineEditLocation
                        editable={GlobalHelper.canEditLocation()}
                        endPoint={'/scheduling-pages/' + this.state.schedulingPageId}
                        value={this.state.locationName}
                        locationId={this.state.locationId} />
                </div>
            </div>
        </div>)

        secondCol.push(<div key={secondCol.length} className="row">
            <div className="form-group row px-3 mb-0">
                <label className="col-12 col-form-label custom-form-label" htmlFor="seller">
                    <FormattedMessage
                        id="scheduling_page.edit.details.available_from_label"
                        defaultMessage="Available from"
                    />
                </label>
                <div className="col-12">
                    <InlineEditSchedulingAvailableFrom
                        editable={true}
                        field={"availableFrom"}
                        endPoint={'/scheduling-pages/' + this.state.schedulingPageId}
                        documentId={this.state.availableFrom} />
                </div>
            </div>
        </div>)

        secondCol.push(<div key={secondCol.length} className="row">
            <div className="form-group row px-3 mb-0">
                <label className="col-12 col-form-label custom-form-label" htmlFor="customFields">
                    <FormattedMessage
                        id="scheduling_page.edit.details.custom_fields_label"
                        defaultMessage="Contact custom fields"
                    />
                </label>
                <div className="col-12">
                    <InlineEditSchedulingCustomFields
                        name={'scheduling-page-custom-fields'}
                        editable={true}
                        schedulingPage={this.state.schedulingPage}
                    />
                </div>
            </div>
        </div>)


        secondCol.push(<div key={firstCol.length} className="form-group row mb-0">
            <label className="col-12 col-form-label custom-form-label">
                <FormattedMessage
                    id="scheduling_page.edit.details.email_confirmation_template_label"
                    defaultMessage="Email confirmation template"
                />
            </label>
            <button
                className="btn btn-outline-primary btn-sm mr-2 mb-2 ml-3" onClick={this.configureBookingConfirmationEmail}>
                <Icon value={"envelope"} className={"mr-1"} />
                <FormattedMessage
                    id="scheduling_page.edit.configure_confirmation_email_btn"
                    defaultMessage="Configure"
                />
            </button>
        </div>)

        /* secondCol.push(<div key={secondCol.length} className="form-group row mb-0">
            <label className="col-12 col-form-label custom-form-label">
                <FormattedMessage
                    id="scheduling_page.edit.details.sharing_description_label"
                    defaultMessage="Sharing description"
                />
            </label>
            <div className="col-12">
                <InlineEditText
                    editable={true}
                    multiLine={true}
                    endPoint={'/scheduling-pages/' + this.state.schedulingPageId}
                    field={'shareDescription'}
                    value={this.state.shareDescription}
                />
            </div>
        </div>) */

        const actions = []

        if (["active", "inactive"].includes(this.state.status)) {
            actions.push(<button key={actions.length} className="btn btn-outline-secondary mb-2 mr-2" onClick={this.closeEditMode}>
                <Icon value={"times"} className={"mr-1"} />
                <FormattedMessage
                    id="invoice.edit.close_edit_btn"
                    defaultMessage="Close edit mode"
                />
            </button>)
        }

        actions.push(<ActionButton key={actions.length} className="btn btn-outline-primary mb-2 mr-2" onClick={this.review}>
            <Icon value={"pencil-ruler"} className={"mr-1"} />
            <FormattedMessage
                id="scheduling_page.edit.edit_design_btn"
                defaultMessage="Edit design"
            />
        </ActionButton>)

        if (this.state.status === 'draft') {
            actions.push(<ActionButton key={actions.length} className="btn btn-outline-primary mr-2 mb-2" onClick={this.markAsInactive}>
                <Icon value={"toggle-off"} className={"mr-1"} />
                <FormattedMessage
                    id="scheduling_page.edit.preview.mark_as_inactive_btn"
                    defaultMessage="Mark as inactive"
                />
            </ActionButton>)

            actions.push(<ActionButton key={actions.length} className="btn btn-success mb-2" onClick={this.markAsActive}>
                <Icon value={"check"} className={"mr-1"} />
                <FormattedMessage
                    id="quote.edit.preview.activate_btn"
                    defaultMessage="Activate"
                />
            </ActionButton>)
        }

        return <div>
            <div className="row mb-5">
                <div className="col-12">
                    {this.state.redirect}
                    {this.state.modal}
                    {this.state.editorModal}

                    <div className="row px-3">
                        <div className="col-12">
                            <h4 className={'custom-lead'}>
                                <FormattedMessage
                                    id="scheduling_page.edit.details.title"
                                    defaultMessage="Details"
                                />
                            </h4>
                        </div>
                    </div>
                    <div className="row m-0 px-3">
                        <div className="col-12 ui-module">
                            <div className="row justify-content-end">
                                <div className="col-sm-12 col-md-6">
                                    <div className="row">
                                        <div className="col-12">
                                            {firstCol}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-6">
                                    {secondCol}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row m-0 py-1 fixed-bottom pr-0 pr-md-5 pr-xl-0">
                <div className={'col-lg-12 mx-auto col-xl-11 pt-3 pl-4 pr-4 pr-md-5 pr-xl-4'}>
                    <div className="col-12 ui-module sticky-bottom-module">
                        <div className="row justify-content-end">
                            {!this.state.deletedAt ? <div className="col-12 d-flex justify-content-between align-content-center flex-wrap">
                                <div className={"d-flex"}>
                                    <div className={""}>
                                        <ConfirmButton
                                            onModalRender={(m, c) => { this.setState({ modal: m }, c) }}
                                            onClick={this.deleteSchedulingPage}
                                            identifier={this.state.identifier}
                                            className="btn btn-outline-danger mr-2 mb-2"
                                        >
                                            <Icon value={"trash"} className={"mr-1"} />
                                            <FormattedMessage
                                                id="scheduling_page.edit.delete_btn"
                                                defaultMessage="Delete"
                                            />
                                        </ConfirmButton>
                                        <ActionButton className={"btn btn-outline-primary mb-2"}
                                                      onClick={this.openPreview}
                                            isLoading={this.state.loadingPreview}>
                                            <Icon value={"eye"} className={"mr-1"} />
                                            <FormattedMessage
                                                id="scheduling_page.edit.preview_btn"
                                                defaultMessage="Preview"
                                            />
                                        </ActionButton>
                                    </div>
                                </div>
                                <div className={""}>
                                    {actions}
                                </div>
                            </div> : <div className="col-12">
                                <p className="text-align-right text-warning m-0">
                                    <FormattedMessage
                                        id="scheduling_page.archived_info"
                                        defaultMessage="This scheduling page is archived and can't be found in search results."
                                    />
                                </p>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

}

export default injectIntl(SchedulingPageEdit)





// WEBPACK FOOTER //
// ./src/scheduling-page/schedulingpage.component.jsx